import { render } from "./LockedHospitalRow.vue?vue&type=template&id=4b89ce4c&scoped=true"
import script from "./LockedHospitalRow.vue?vue&type=script&lang=js"
export * from "./LockedHospitalRow.vue?vue&type=script&lang=js"

import "./LockedHospitalRow.vue?vue&type=style&index=0&id=4b89ce4c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b89ce4c"]])

export default __exports__